<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div>
            <base-collapsible class="mb-3"
              customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
              <template slot="headerRight">
                <div class="flex flex-col py-2">
                  <h2 class="dark:text-darkblue-100">{{ $t('impuestos.TaxRate_from_to') }}</h2>
                </div>
              </template>
              <template slot="content">
                <div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                    <el-form-item prop="taxRateMin">
                      <el-input clearable class="w-full" v-model="form.taxRateMin.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                    <el-form-item prop="taxRateMax">
                      <el-input clearable class="w-full" v-model="form.taxRateMax.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible>
          </div>

          <div>
            <base-collapsible class="mb-3"
              customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
              <template slot="headerRight">
                <div class="flex flex-col py-2">
                  <h2 class="dark:text-darkblue-100">{{ $t('impuestos.equivalence_surcharge_filter') }}</h2>
                </div>
              </template>
              <template slot="content">
                <div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                    <el-form-item prop="equivalenceSurchargeMin">
                      <el-input clearable class="w-full" v-model="form.equivalenceSurchargeMin.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                    <el-form-item prop="equivalenceSurchargeMax">
                      <el-input clearable class="w-full" v-model="form.equivalenceSurchargeMax.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible>
          </div>

          <div class="lg:mb-2">

            <div v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('distributors.entity_name') }}</label>
                <el-form-item prop="distribuidor">
                  <base-el-select class="w-full" :options="distribuidores" v-model="form.distribuidor.value" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
              <el-form-item prop="empresa">
                <base-el-select class="w-full" :options="clientes" v-model="form.empresa.value" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="Name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('impuestos.TaxType')}}</label>
              <el-form-item prop="TaxType">
                <base-el-select class="w-full" :options="tiposCodigoImpuesto" v-model="form.TaxType.value" clearable filterable/>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('impuestos.TaxCategory') }}</label>
              <el-form-item prop="TaxCategory">
                <base-el-select class="w-full" :options="tiposCategoriaImpuesto" v-model="form.TaxCategory.value" clearable filterable/>
              </el-form-item>
            </div>
 
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'impuestos',
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingClientes: false,
      form: {
        Name: { label: i18n.t('app.name'), value: '' },
        TaxType: { label: i18n.t('impuestos.TaxType'), value: '' },
        TaxCategory: { label: i18n.t('impuestos.TaxCategory'), value: '' },
        taxRateMin: { label: i18n.t('impuestos.TaxRate_min'), value: '' },
        taxRateMax: { label: i18n.t('impuestos.TaxRate_max'), value: '' },
        equivalenceSurchargeMin: { label: i18n.t('impuestos.equivalence_surcharge_min'), value: '' },
        equivalenceSurchargeMax: { label: i18n.t('impuestos.equivalence_surcharge_max'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
    tiposCategoriaImpuesto: function () {
      return this.$store.getters['config/TIPOS_CATEGORIA_IMPUESTOS']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Name.value = _temp.Name !== undefined && _temp.Name.value !== '' ? _temp.Name.value : ''
        this.form.TaxType.value = _temp.TaxType !== undefined && _temp.TaxType.value !== '' ? _temp.TaxType.value : ''
        this.form.TaxCategory.value = _temp.TaxCategory !== undefined && _temp.TaxCategory.value !== '' ? _temp.TaxCategory.value : ''
        this.form.taxRateMin.value = _temp.taxRateMin !== undefined && _temp.taxRateMin.value !== '' ? _temp.taxRateMin.value : ''
        this.form.taxRateMax.value = _temp.taxRateMax !== undefined && _temp.taxRateMax.value !== '' ? _temp.taxRateMax.value : ''
        this.form.equivalenceSurchargeMin.value = _temp.equivalenceSurchargeMin !== undefined && _temp.equivalenceSurchargeMin.value !== '' ? _temp.equivalenceSurchargeMin.value : ''
        this.form.equivalenceSurchargeMax.value = _temp.equivalenceSurchargeMax !== undefined && _temp.equivalenceSurchargeMax.value !== '' ? _temp.equivalenceSurchargeMax.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Name: { label: i18n.t('app.name'), value: '' },
        TaxType: { label: i18n.t('impuestos.TaxType'), value: '' },
        TaxCategory: { label: i18n.t('impuestos.TaxCategory'), value: '' },
        taxRateMin: { label: i18n.t('impuestos.TaxRate_min'), value: '' },
        taxRateMax: { label: i18n.t('impuestos.TaxRate_max'), value: '' },
        equivalenceSurchargeMin: { label: i18n.t('impuestos.equivalence_surcharge_min'), value: '' },
        equivalenceSurchargeMax: { label: i18n.t('impuestos.equivalence_surcharge_max'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' }
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
